import { useCallback, useMemo } from 'react';
import { startOfDay, addDays } from 'date-fns';
import { getInitialStartBillingAtDate, getMinimumEffectiveDate } from "../../../../ServiceAdvancedSettings/ServiceAdvancedSettings.utils";
import { useIoContext } from "../../../../../contexts";
export const useStartBillingDates = _ref => {
  let {
    relationshipEffectiveDate,
    isAmendedService
  } = _ref;
  const {
    getNow
  } = useIoContext();
  const getToday = useCallback(() => startOfDay(getNow()), [getNow]);
  const getTomorrow = useCallback(() => addDays(getToday(), 1), [getToday]);
  const getInitialEffectiveDate = useCallback(() => {
    return getInitialStartBillingAtDate({
      now: getNow(),
      relationshipEffectiveDate,
      isAmendedService
    });
  }, [getNow, relationshipEffectiveDate, isAmendedService]);
  const minimumEffectiveDate = useMemo(() => getMinimumEffectiveDate({
    now: getNow(),
    relationshipEffectiveDate,
    isAmendedService
  }), [getNow, relationshipEffectiveDate, isAmendedService]);
  return {
    getToday,
    getTomorrow,
    minimumEffectiveDate,
    getInitialEffectiveDate
  };
};